export class FlagTicketCount {
  public flag_count: number;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/model/flag-ticket-count.ts